import { baseMenuConf } from '@/conf'
import { getRoletype } from '@/utils/getUser'
import { getAccountId } from '@/directives/permission'

/**
 * 判断菜单项对当前角色/账号是否可见。
 * 菜单层(ui-menu / ui-menu-tree)与路由层(router.beforeEach)共用此函数,避免逻辑分叉。
 *
 * - 父菜单(有 children):任一子可见则可见(与历史父级 hideByRoleType 行为等价)
 * - 叶子菜单:优先 roles 白名单命中;再叠加 accountIds 账号特例(报单汇总)
 * - 兼容旧 hideByRoleType:仅在未配 roles/accountIds 时回退,迁移期保险
 */
export function isMenuVisible (item, roleType, accountId) {
  if (item.children && item.children.length) {
    return item.children.some(child => isMenuVisible(child, roleType, accountId))
  }
  let visible = true
  if (Array.isArray(item.roles)) visible = item.roles.includes(roleType)
  if (Array.isArray(item.accountIds) && item.accountIds.length) {
    visible = visible || item.accountIds.includes(accountId) // 报单汇总:角色或账号任一命中
  }
  if (!Array.isArray(item.roles) && !Array.isArray(item.accountIds)
      && typeof item.hideByRoleType === 'function') {
    visible = item.hideByRoleType(roleType)
  }
  return visible
}

/**
 * 递归收集当前角色有权限的所有叶子节点 url
 */
function collectAllowedUrls (menuList, roleType, accountId, result = []) {
  for (const item of menuList) {
    if (!isMenuVisible(item, roleType, accountId)) continue

    if (item.children && item.children.length) {
      collectAllowedUrls(item.children, roleType, accountId, result)
    } else if (item.url) {
      result.push(item.url)
    }
  }
  return result
}

/**
 * 获取当前登录角色所有有权限的路由 url 列表
 */
export function getAllowedUrls () {
  const roleType = getRoletype()
  // roleType 还未加载时(如刚登录跳转中)不做拦截
  if (!roleType) return []
  return collectAllowedUrls(baseMenuConf, roleType, getAccountId())
}

/**
 * 判断某个路径是否在有权限的路由中(支持前缀匹配)
 */
export function isPathAllowed (path, allowedUrls) {
  return allowedUrls.some(url => path === url || path.startsWith(url + '/'))
}

/**
 * 获取第一个有权限的页面 url,用于无权限时的跳转兜底
 */
export function getFirstAllowedUrl () {
  const urls = getAllowedUrls()
  return urls[0] || null
}
